import { Translation } from '@shared/types/translation';

export const SUBSCRIPTION_MANAGEMENT_LABELS = {
  STEP_PLAN_DETAILS: {
    english: 'Plan Details',
    polish: 'Szczegóły planu',
  },
  STEP_SERVICES: {
    english: 'Services',
    polish: 'Usługi',
  },
  STEP_EQUIPMENT_PRICING: {
    english: 'Equipment Pricing',
    polish: 'Wycena aparatury',
  },
  STEP_DISCOUNT_LOGIC: {
    english: 'Discount Logic',
    polish: 'Logika rabatów',
  },
  EQUIPMENT_RANK_PREFIX: {
    english: 'Equipment',
    polish: 'Aparatura',
  },
  BUTTON_BACK: {
    english: 'Back',
    polish: 'Wstecz',
  },
  BUTTON_CANCEL: {
    english: 'Cancel',
    polish: 'Anuluj',
  },
  BUTTON_NEXT: {
    english: 'Next',
    polish: 'Dalej',
  },
  BUTTON_CREATE_PLAN: {
    english: 'Create Plan',
    polish: 'Utwórz plan',
  },
  FIELD_OPTIONAL: {
    english: '(Optional)',
    polish: '(Opcjonalne)',
  },
  BUTTON_CONTINUE_EDITING: {
    english: 'Continue Editing',
    polish: 'Kontynuuj edycję',
  },
  BUTTON_BACK_TO_EDIT: {
    english: 'Back to Edit',
    polish: 'Wróć do edycji',
  },
  PREVIEW_PLAN_TITLE: {
    english: 'Preview Plan',
    polish: 'Podgląd planu',
  },
  HEADING_EDIT_PLAN_CONFIRM: {
    english: 'Edit Subscription Plan?',
    polish: 'Edytować plan subskrypcji?',
  },
  INFO_BILLING_DESCRIPTION_DEFAULT: {
    english:
      'The price will be billed on the selected billing cycle for the selected duration.',
    polish:
      'Cena będzie naliczana zgodnie z wybranym cyklem rozliczeniowym przez wybrany okres.',
  },
  INFO_ACTIVE_CLIENTS_WARNING_PREFIX: {
    english: 'This subscription plan is currently assigned to',
    polish: 'Ten plan subskrypcji jest obecnie przypisany do',
  },
  INFO_ACTIVE_CLIENTS_WARNING_SUFFIX: {
    english:
      'active clients. Any changes you make will affect their future billing calculations.',
    polish:
      'aktywnych klientów. Wszelkie wprowadzone zmiany wpłyną na ich przyszłe rozliczenia.',
  },
  FIELD_PLAN_NAME: {
    english: 'Plan Name',
    polish: 'Nazwa planu',
  },
  FIELD_DURATION_TYPE: {
    english: 'Duration Type',
    polish: 'Typ okresu',
  },
  FIELD_DURATION: {
    english: 'Duration',
    polish: 'Okres',
  },
  FIELD_BILLING_CYCLE: {
    english: 'Billing Cycle',
    polish: 'Cykl rozliczeniowy',
  },
  CYCLE_MONTHLY: {
    english: 'Monthly',
    polish: 'Miesięczny',
  },
  CYCLE_QUARTERLY: {
    english: 'Quarterly',
    polish: 'Kwartalny',
  },
  CYCLE_YEARLY: {
    english: 'Yearly',
    polish: 'Roczny',
  },
  CYCLE_SUFFIX_MONTHLY: {
    english: '/mo',
    polish: '/mies.',
  },
  CYCLE_SUFFIX_QUARTERLY: {
    english: '/qtr',
    polish: '/qtr',
  },
  CYCLE_SUFFIX_YEARLY: {
    english: '/yr',
    polish: '/rok',
  },
  FIELD_USAGE_LIMITS: {
    english: 'Usage Limits',
    polish: 'Limity użytkowania',
  },
  FIELD_NUMBER_OF_USERS: {
    english: 'Number of Users',
    polish: 'Liczba użytkowników',
  },
  FIELD_NUMBER_OF_FACILITIES: {
    english: 'Number of Facilities',
    polish: 'Liczba placówek',
  },

  FIELD_MAX_USERS_HINT: {
    english: 'Maximum allowed: 500 users',
    polish: 'Maksymalnie: 500 użytkowników',
  },
  FIELD_MAX_FACILITIES_HINT: {
    english: 'Maximum allowed: 10 facilities',
    polish: 'Maksymalnie: 10 placówek',
  },
  FIELD_NUMBER_OF_QMS_DOCUMENTS: {
    english: 'Number of QMS Documents',
    polish: 'Liczba dokumentów QMS',
  },
  FIELD_DESCRIPTION: {
    english: 'Description',
    polish: 'Opis',
  },
  SECTION_OFFER: {
    english: 'Offer',
    polish: 'Oferta',
  },
  FIELD_DISCOUNT: {
    english: 'Discount',
    polish: 'Rabat',
  },
  FIELD_SELECT_DISCOUNT: {
    english: 'Select Discount',
    polish: 'Wybierz rabat',
  },
  FIELD_DISCOUNT_HELPER: {
    english: "Optionally apply a discount offer to this plan's base price.",
    polish: 'Opcjonalnie zastosuj ofertę rabatową do ceny bazowej tego planu.',
  },
  FIELD_BASE_PRICE: {
    english: 'Base Price',
    polish: 'Cena bazowa',
  },
  FIELD_ADD_SERVICE: {
    english: 'Add Service',
    polish: 'Dodaj usługi',
  },
  FIELD_SERVICE: {
    english: 'Service',
    polish: 'Usługa',
  },
  FIELD_SELECT_A_SERVICE: {
    english: 'Select a Service',
    polish: 'Wybierz usługę',
  },
  FIELD_SERVICE_TYPE: {
    english: 'Service Type',
    polish: 'Typ usługi',
  },
  FIELD_SERVICE_PRICE: {
    english: 'Service Price',
    polish: 'Cena usługi',
  },
  FIELD_ORIGINAL_PRICE_HELPER: {
    english: 'Original price charged after the usage limit is reached.',
    polish: 'Cena pierwotna naliczana po osiągnięciu limitu użytkowania.',
  },
  FIELD_DISCOUNT_PERCENTAGE: {
    english: 'Discount in Percentage',
    polish: 'Rabat procentowy',
  },
  FIELD_DEDUCTED_HELPER: {
    english: 'Deducted from the service price.',
    polish: 'Odliczany od ceny usługi.',
  },
  FIELD_USAGE_LIMIT: {
    english: 'Usage Limit',
    polish: 'Limit użytkowania',
  },
  FIELD_BASE_PRICE_LIMIT_HELPER: {
    english: 'Base price applies after this limit.',
    polish: 'Po przekroczeniu tego limitu obowiązuje cena bazowa.',
  },
  FIELD_EQUIPMENT_PRICING_HELPER: {
    english:
      'Set a base maintenance price for each equipment category. Discounts are auto-assigned and can be adjusted per category.',
    polish:
      'Ustaw bazową cenę serwisu dla każdej kategorii aparatury. Rabaty są przypisywane automatycznie i można je dostosować dla każdej kategorii.',
  },
  FIELD_DISCOUNT_TIERS_HELPER: {
    english:
      'Pre-filled discount tiers per equipment quantity. Values can be adjusted.',
    polish:
      'Wstępnie uzupełnione progi rabatowe według liczby aparatury. Wartości można dostosować.',
  },
  FIELD_PLAN_DISCOUNT_PERCENTAGE: {
    english: 'Plan Discount in Percentage',
    polish: 'Rabat planu (procentowo)',
  },
  FIELD_CLIENTS: {
    english: 'Clients',
    polish: 'Klienci',
  },
} as const satisfies Record<string, Translation>;

// Keyed by the equipment_categories seed name (Polish, the DB source of
// truth) so a raw category label can be translated for display.
export const EQUIPMENT_CATEGORY_LABELS = {
  INTRAORAL_XRAY_POINT: {
    english: 'Intraoral X-ray (Point)',
    polish: 'Aparat Punktowy',
  },
  PANORAMIC_XRAY: {
    english: 'Panoramic X-ray',
    polish: 'Aparat Pantomograficzny',
  },
  PANORAMIC_CEPHALOMETRY: {
    english: 'Panoramic + Cephalometry',
    polish: 'Aparat Pantomograficzny + Cefalometria',
  },
  PANORAMIC_CBCT: {
    english: 'Panoramic + CBCT',
    polish: 'Aparat Pantomograficzny + CBCT',
  },
  PANORAMIC_CBCT_CEPHALOMETRY: {
    english: 'Panoramic + CBCT + Cephalometry',
    polish: 'Aparat Pantomograficzny + CBCT + Cefalometria',
  },
  COMPUTED_TOMOGRAPHY: {
    english: 'Computed Tomography',
    polish: 'Aparat CT',
  },
  C_ARM: {
    english: 'C-Arm',
    polish: 'Aparat Ramię C',
  },
  GENERAL_DIAGNOSTIC_XRAY: {
    english: 'General Diagnostic X-ray',
    polish: 'Aparat Ogólnodiagnostyczny',
  },
} as const satisfies Record<string, Translation>;
